import React from 'react';
import Select from 'react-styled-select';

const options = [
    { label: "A", value: 'A'},
    { label: "B", value: 'B'},
    { label: "C", value: 'C'},
    { label: "D", value: 'D'},
    { label: "E", value: 'E'},
  ]

export class CategoryDropDownMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    generateDropDown = () => {
        switch (this.props.CategoryDropDownMenu) {
            case 'edit':
                return (
                    <Select
                        options={options}
                        onChange={this.props.handler}
                        value={this.props.category}
                        multi
                        classes={{
                            selectInputField: 'styled-select-input-field',
                            selectControl: 'styled-select-control',
                            selectPlaceholder: 'styled-select-placeholder',
                            selectValue: 'styled-select-value',
                            selectArrow: 'styled-select-arrow'
                        }}
                    />
                );
            default:
            
        }
    };

    render() {
        return (
            <div className={`formDropDown ${this.props.extraClasses}`}>
                <label> {this.props.label} </label>
                <div>{this.generateDropDown()}</div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/customModules/Common/form/CategoryDropDownMenu.js